import {Form, Input, Row, Col} from 'antd';
import React, {useContext, useEffect} from 'react';
import WangEditor from "../common/WangEditor";
import {sideMenuContext} from "../../../router/IndexRouter";
import AddFormComponent from "../common/AddFormComponent";
import EditFormComponent from "../common/EditFormComponent";
import {Arguments} from "../common/Arguments";
import SaveButtonComponent from "../common/SaveButtonComponent";
import TextArea from "antd/es/input/TextArea";
import {validateEditorContent, validateWhiteSpace} from "../common/ValidateWhiteSpace";

const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
};
const tailLayout = {
    wrapperCol: {offset: 4, span: 16},
};

const formRef = React.createRef()

const AddSocietyRecognition = () => {
    const currentUrl = window.location.href;
    // 获取 WangEditor 中的内容
    const {editorContent} = useContext(sideMenuContext);
    const apiList = [Arguments.host + "/society_organization/society/api!addSocietyRecognition.do"];

    useEffect(() => {
        formRef.current.setFieldsValue({
            prizeContent: editorContent
        })
    }, [editorContent])

    return (currentUrl.endsWith("add") ? <AddFormComponent UserForm={SocietyRecognitionForm} url={apiList}/> :
        <EditFormComponent UserForm={SocietyRecognitionForm} url={apiList}/>
    )
}

const SocietyRecognitionForm = ({onFinish, initialValues}) => {
    const [form] = Form.useForm();

    return (
        <Form
            {...layout}
            form={form}
            onFinish={onFinish}
            initialValues={initialValues}
            name="control-hooks"
            style={{maxWidth: 1200, marginLeft: 40}}
            ref={formRef}
        >
            <Row align='top'>
                <Col span={12}>
                    <Form.Item name="prizeYear" label="授奖年度" rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="prizeName" label="授奖名称" rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align='top'>
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="prizeMemo" label="说明" rules={[{required: true, validator: validateWhiteSpace}]}>
                        <TextArea rows={4}/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align='top'>
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="prizeContent" label="详细信息" rules={[{required: true, validator: validateEditorContent}]}>
                        <WangEditor defaultValue={initialValues?.prizeContent}/>
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item {...tailLayout}>
                <SaveButtonComponent/>
            </Form.Item>
        </Form>
    )
}

export default AddSocietyRecognition;